const PayrollDeleteTaskTableHeaders = () => [
];

const PayrollDeleteTaskItemFormatters = () => [
];

export { PayrollDeleteTaskTableHeaders, PayrollDeleteTaskItemFormatters };
